export const lightDangerColors = {
    // TEXT
    dangerText: 'var(--theme-ui-colors-plumText)',
    dangerTextWeak: 'var(--theme-ui-colors-plum)',
    dangerTextActive: 'var(--theme-ui-colors-gojiBerry)',
    // BACKGROUND
    dangerBg: 'var(--theme-ui-colors-lychee)',
    dangerBgMedium: 'var(--theme-ui-colors-plum)',
    dangerBgMediumActive: 'var(--theme-ui-colors-gojiBerry)',
    // BORDER
    dangerBorder: 'var(--theme-ui-colors-plum)',
    dangerBorderActive: 'var(--theme-ui-colors-gojiBerry)',
    // ICON
    dangerIcon: 'var(--theme-ui-colors-plum)',
    dangerIconActive: 'var(--theme-ui-colors-gojiBerry)',
};
export const darkDangerColors = {
    // TEXT
    dangerText: 'var(--theme-ui-colors-plumText)',
    dangerTextWeak: 'var(--theme-ui-colors-plum)',
    dangerTextActive: 'var(--theme-ui-colors-gojiBerry)',
    // BACKGROUND
    dangerBg: 'var(--theme-ui-colors-lychee)',
    dangerBgMedium: 'var(--theme-ui-colors-plum)',
    dangerBgMediumActive: 'var(--theme-ui-colors-gojiBerry)',
    // BORDER
    dangerBorder: 'var(--theme-ui-colors-plum)',
    dangerBorderActive: 'var(--theme-ui-colors-gojiBerry)',
    // ICON
    dangerIcon: 'var(--theme-ui-colors-plum)',
    dangerIconActive: 'var(--theme-ui-colors-gojiBerry)',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGFuZ2VyQ29sb3JzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3RoZW1lL3NlbWFudGljQ29sb3JzL2RhbmdlckNvbG9ycy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLENBQUMsTUFBTSxpQkFBaUIsR0FBRztJQUMvQixPQUFPO0lBQ1AsVUFBVSxFQUFFLGlDQUFpQztJQUM3QyxjQUFjLEVBQUUsNkJBQTZCO0lBQzdDLGdCQUFnQixFQUFFLGtDQUFrQztJQUVwRCxhQUFhO0lBQ2IsUUFBUSxFQUFFLCtCQUErQjtJQUN6QyxjQUFjLEVBQUUsNkJBQTZCO0lBQzdDLG9CQUFvQixFQUFFLGtDQUFrQztJQUV4RCxTQUFTO0lBQ1QsWUFBWSxFQUFFLDZCQUE2QjtJQUMzQyxrQkFBa0IsRUFBRSxrQ0FBa0M7SUFFdEQsT0FBTztJQUNQLFVBQVUsRUFBRSw2QkFBNkI7SUFDekMsZ0JBQWdCLEVBQUUsa0NBQWtDO0NBQ3JELENBQUM7QUFFRixNQUFNLENBQUMsTUFBTSxnQkFBZ0IsR0FBNkI7SUFDeEQsT0FBTztJQUNQLFVBQVUsRUFBRSxpQ0FBaUM7SUFDN0MsY0FBYyxFQUFFLDZCQUE2QjtJQUM3QyxnQkFBZ0IsRUFBRSxrQ0FBa0M7SUFFcEQsYUFBYTtJQUNiLFFBQVEsRUFBRSwrQkFBK0I7SUFDekMsY0FBYyxFQUFFLDZCQUE2QjtJQUM3QyxvQkFBb0IsRUFBRSxrQ0FBa0M7SUFFeEQsU0FBUztJQUNULFlBQVksRUFBRSw2QkFBNkI7SUFDM0Msa0JBQWtCLEVBQUUsa0NBQWtDO0lBRXRELE9BQU87SUFDUCxVQUFVLEVBQUUsNkJBQTZCO0lBQ3pDLGdCQUFnQixFQUFFLGtDQUFrQztDQUNyRCxDQUFDIn0=